import { lazy } from "react";
import FoodicsCallbackRedirect from "../components/foodics/FoodicsCallbackRedirect";
import { adminRoutes } from "./admin.routes";
import { customerRoutes } from "./customer.routes";
import { organizerRoutes } from "./organizer.routes";
import { ownerRoutes } from "./owner.routes";
import { storeRoutes } from "./store.routes";
import { organizationRoutes } from "./organization.routes";

const NotFound = lazy(() => import("../pages/NotFound"));
const PrivacyPloicy = lazy(() => import("../pages/PrivacyPloicy"));
const ConnectFoodicsPage = lazy(() => import("../features/foodics/pages/connect-foodics"));



export const routes = [
  { path: "/connect-foodics", element: <ConnectFoodicsPage /> },
  { path: "/", element: <FoodicsCallbackRedirect /> },

  ...adminRoutes,
  ...storeRoutes,
  ...ownerRoutes,
  ...customerRoutes,
  ...organizerRoutes,
  ...organizationRoutes,
  { path: "*", element: <NotFound /> },
  // privacy policy
  { path: "/privacy-policy", element: <PrivacyPloicy /> },
];